export default "__VITE_ASSET__NgJe_8EP__"